export const apiUrls = {
  survey: `${process.env.REACT_APP_API_URL}/survey/api`,
};
